const categorySc = [
  "法律服务",
  "影视行业",
  "农业",
  "建筑工程",
  "教育",
  "电子",
  "能源",
  "娱乐",
  "电子商务",
  "金融",
  "医疗保健",
  "酒店及餐饮",
  "进口/出口贸易及批发",
  "知识产权",
  "信息科技",
  "授权/牌照",
  "机械设备",
  "制造业",
  "媒体及传播",
  "采矿和挖掘",
  "制药",
  "商业服务",
  "房地产",
  "零售",
  "社会及个人服务",
  "检测及实验室",
  "纺织及制衣",
  "仓库及速递服务业",
  "公用事业",
  "废弃物管理",
  "会计",
  "银行",
  "保险",
  '非牟利组织',
  '非政府组织',
  '检测及认证',
  '市场推广服务',
  "其他"
];

export default categorySc;
